import React, { useEffect } from "react";
import styles from "./Home.module.css"; // Import the CSS module
import newBanner from "./newBanner.webp";
import ButtonComponent from "../../CssComponents/ButtonComponent/ButtonComponent";

function Home({ onOpenLaunch }) {


    useEffect(() => {
        // Add the 'revealed' class after a small delay to trigger the animation
        const highlightElements = document.querySelectorAll(
            "." + CSS.escape(styles.homeHookHighlight)
        );
        highlightElements.forEach((el) => {
            setTimeout(() => el.classList.add(styles.revealed), 500);
        });
    }, []);

    return (
        <div className={styles.home}>
            
            <div className={styles.homeTextWrapper}>
                <div className={styles.homeHeading}>Welcome to the future!</div>
                <div className={styles.homeHook}>
                    The only{" "}
                    <span className={styles.homeHookHighlight}>place</span> where you can
                    earn Real <span className={styles.homeHookHighlight}>Cash</span>.
                </div>
                <div className={styles.homeTag}>
                    Learn, Earn and Jackpot - Zero Investment!
                </div>

                <ButtonComponent
                    buttonText={"LAUNCH"}
                    onClick={onOpenLaunch}
                    className={styles.homeBtn}
                />
            </div>

            <div className={styles.homeImgSvgWrapper}>
                <div className={styles.homeImgWrapper}>
                    <img
                        src={newBanner}
                        alt="home-img"
                        className={styles.homeImg}
                    />
                </div>
            </div>
        </div>
    );
}

export default Home;
